(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_review-card"] && !Shopify.designMode) return;
  try {
    class ReviewCardText extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.button = this.querySelector('[data-review-read-more]');
      this.text = this.querySelector('[data-review-text]');
      if (!this.button || !this.text) return;
      this.initialized = true;
      this.moreLabel = this.button.getAttribute('data-label-more');
      this.lessLabel = this.button.getAttribute('data-label-less');
      this.updateOverflow();
      this.button.addEventListener('click', () => this.toggle());
      this.resizeObserver = new ResizeObserver(() => this.updateOverflow());
      this.resizeObserver.observe(this.text);
    }

    disconnectedCallback() {
      if (this.resizeObserver) this.resizeObserver.disconnect();
    }

    updateOverflow() {
      if (this.text.getAttribute('data-collapsed') === 'false') return;
      this.button.hidden = this.text.scrollHeight <= this.text.clientHeight + 1;
    }

    toggle() {
      const collapsed = this.text.getAttribute('data-collapsed') !== 'false';
      this.text.setAttribute('data-collapsed', collapsed ? 'false' : 'true');
      this.button.textContent = collapsed ? this.lessLabel : this.moreLabel;
      this.button.setAttribute('aria-expanded', collapsed ? 'true' : 'false');
      if (!collapsed) {
        requestAnimationFrame(() => this.updateOverflow());
      }
    }
  }

  if (!customElements.get('review-card-text')) {
    customElements.define('review-card-text', ReviewCardText);
  }
  } catch(e) { console.error(e); }
})();

})();
